import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ToggleFilterComponent } from './toggle-filter.component';

@NgModule({
  imports: [CommonModule],
  declarations: [ToggleFilterComponent],
  exports: [ToggleFilterComponent],
})
export class ToggleFilterModule {}
